import SystemFieldProto from '../../proto/system-field-proto';
import mapByUserName from "../../import/normalize/map-user";
import SystemFieldUserViewInImport from "../../import/view-in-preview/user-view-in-preview";
import FieldShortTextViewInImport from "../../import/view-in-preview/short-text-in-preview";


export default class TitleField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);

        this.type = gd.const.fields.type.TITLE;
    }

    get sortHintMessage() {
        return 'Sort by title';
    }

    getCsvValue(item) {
        return item.title ? item.title /*for tasks*/ : item.name /*for projects*/;
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => i.getName().toLowerCase()],
            directions: [sort]
        }
    }


    // Universal - experimental vic
    sortValue(value) {
        return value.toLowerCase();
    }




    // IMPORT

    normalizeCSVValue(value) {
        return value?value.trim():null;
    }

    getComponentViewInImport() {
        return FieldShortTextViewInImport;
    }

}
